import { twMerge } from 'tailwind-merge';
import PercentageBar from '@/components/PercentageBar';
import { classes } from './utils';

export type ComparisonBarsProps = {
  showLabels?: boolean;
  className?: string;
  previousLabel?: string;
  currentLabel?: string;
  previousValue?: string;
  currentValue?: string;
  previousWidth: number;
  currentWidth: number;
};

export default function ComparisonBars({
  showLabels,
  className,
  previousLabel,
  currentLabel,
  previousValue,
  currentValue,
  previousWidth,
  currentWidth,
}: ComparisonBarsProps) {
  const previousBar = (
    <PercentageBar
      className={classes.bar}
      fillClassName={classes.previousFill}
      width={previousWidth}
    />
  );
  const currentBar = (
    <PercentageBar className={classes.bar} width={currentWidth} />
  );

  if (!showLabels) {
    return (
      <div className={twMerge(classes.compact, className)}>
        {previousBar}
        {currentBar}
      </div>
    );
  }

  return (
    <div className={twMerge(classes.grid, className)}>
      <span className={classes.previousTag}>{previousLabel}</span>
      {previousBar}
      <span className={classes.previousValue}>{previousValue}</span>
      <span className={classes.currentTag}>{currentLabel}</span>
      {currentBar}
      <span className={classes.currentValue}>{currentValue}</span>
    </div>
  );
}
